export default __webpack_public_path__ + "static/both-thco-774aa67808708a12bf009f1c06c96bfa.png";